import { useMutation, useQueryClient } from "@tanstack/react-query";
import Cookies from "js-cookie";
import { toast } from "sonner";
import { AxiosError } from "axios";

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog/dialog";

import { Button } from "@/components/ui/button/button";
import { deleteLoanAsAdmin } from "@/config/mutation/admin";
import { useDeleteLoanModal } from "./use-delete-loan-modal";

export const DeleteLoanModal = () => {
  const queryClient = useQueryClient();
  const key = Cookies.get("key") as string;
  const { open, onOpenChange, loanId } = useDeleteLoanModal();

  const { mutate, isPending } = useMutation({
    mutationFn: deleteLoanAsAdmin(key),
  });

  const submitAction = async () => {
    mutate(
      {
        loanId,
      },
      {
        onSuccess: async () => {
          // console.log("New Employee", data);
          await queryClient.invalidateQueries({
            queryKey: ["loans"],
          });

          toast.success("Loan Deleted!");
          onOpenChange(false);
        },

        onError: (error) => {
          console.log("ERROR WHILE DELETING LOAN", error);
          const isAxiosError = error instanceof AxiosError;
          if (isAxiosError) {
            const errorReason = error?.response?.data?.error as string;
            toast.error(errorReason);
          } else {
            toast.error(error?.message);
          }
        },
      }
    );
  };

  return (
    <>
      <Dialog open={open} onOpenChange={onOpenChange}>
        <DialogContent className="max-w-xl">
          <DialogHeader>
            <DialogTitle className="tracking-normal">
              Do you want to delete loan?
            </DialogTitle>
          </DialogHeader>

          <div className="flex items-center justify-end">
            <Button
              onClick={submitAction}
              disabled={isPending}
              variant="destructive"
            >
              Delete
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
